import BusinessSector from "./BusinessSector";
import Model from "./Model";

export class CompanyFilter {
  name?: string;
  typology?: string;
  page?: number;
  per?: string;

  toParams() {
    const params = [];
    if (this.name) {
      params.push(`filter[name]=${encodeURIComponent(this.name)}`);
    }
    if (this.typology) {
      params.push(`filter[typology]=${encodeURIComponent(this.typology)}`);
    }
    if (this.page && this.page > 0) {
      params.push(`page=${encodeURIComponent(this.page)}`);
    }
    if (this.per) {
      params.push(`per=${encodeURIComponent(this.per)}`);
    }
    const base = "?include=*";
    if (params.length > 0) {
      return `${base}&${params.join("&")}`;
    }
    return base;
  }
}

export const Typologies = [
  {
    id: "lead",
    text: "Lead",
  },
  {
    id: "prospect",
    text: "Prospetto",
  },
  {
    id: "client",
    text: "Cliente",
  },
];

export enum CLIENT_TYPOLOGY {
  LEAD = "lead",
  PROSPECT = "prospect",
  CLIENT = "client",
}

export default class Company extends Model {
  static type = "companies";

  name!: string;
  typology!: string;
  businessSector?: BusinessSector;
  siteUrl?: string;
  email?: string;
  phoneNumber?: string;
  pec?: string;
  contactName?: string;
  contactEmail?: string;
  contactPhoneNumber?: string;
  notes?: string;
  croppedLogo?: string;
  createdAt?: string;
  updatedAt?: string;

  static empty() {
    const company = new Company();
    company.name = "";
    company.typology = "lead";
    return company;
  }

  toJson() {
    return {
      name: this.name,
      typology: this.typology,
      businessSectorId: this.businessSector?.id,
      siteUrl: this.siteUrl,
      email: this.email,
      phoneNumber: this.phoneNumber,
      pec: this.pec,
      contactName: this.contactName,
      contactEmail: this.contactEmail,
      contactPhoneNumber: this.contactPhoneNumber,
      notes: this.notes,
    };
  }
}
